import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { domain } from '../common/domain';

function Products() {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subcategories, setSubcategories] = useState([]);
  const [purityLevels, setPurityLevels] = useState([]);
  const [counters, setCounters] = useState([]);
  const [salespersons, setSalespersons] = useState([]);

  const [newProduct, setNewProduct] = useState({
    name: '',
    category_id: '',
    sub_category_id: '',
    counter_id: '',
    salesperson_id: '',
    weight: '',
    purity_id: '',
    quantity: '', 
    orginal_price: ""
  });

  const [editingIndex, setEditingIndex] = useState(-1);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [cats, subs, purity, counters, sales, prods] = await Promise.all([
        axios.get(domain() + '?endpoint=categories'),
        axios.get(domain() + '?endpoint=subcategories'),
        axios.get(domain() + '?endpoint=purity'),
        axios.get(domain() + '?endpoint=counters'),
        axios.get(domain() + '?endpoint=salespersons'),
        axios.get(domain() + '?endpoint=products'),
      ]);

      setCategories(cats.data);
      setSubcategories(subs.data);
      setPurityLevels(purity.data);
      setCounters(counters.data);
      setSalespersons(sales.data);
      setProducts(prods.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleChange = (e) => {
    setNewProduct({ ...newProduct, [e.target.name]: e.target.value });
  };

  const handleAddOrUpdateProduct = async () => {
    try {
      const formData = new FormData();
      
      Object.entries(newProduct).forEach(([key, value]) => {
        formData.append(key, value);
      });
      formData.append('total_weight', newProduct.quantity * newProduct.weight);
      formData.append('total_orginal_price', newProduct.quantity * newProduct.orginal_price);

      if (editingIndex === -1) {
        const response = await axios.post(domain() + '?endpoint=products', formData);
        setProducts([...products, { ...newProduct, id: response.data.id }]);
      } else {
        formData.append('_method', "PUT");
        await axios.post(`${domain()}?endpoint=products&id=${products[editingIndex].id}`, formData);
        const updatedProducts = [...products];
        updatedProducts[editingIndex] = { ...newProduct, id: products[editingIndex].id };
        setProducts(updatedProducts);
        setEditingIndex(-1);
      }
      setNewProduct({
        name: '',
        category_id: '',
        sub_category_id: '',
        counter_id: '',
        salesperson_id: '',
        weight: '',
        purity_id: '',
        quantity: '',
        orginal_price: ''
      });
    } catch (error) {
      console.error('Error adding/updating product:', error);
    }
  };

  const handleEdit = (index) => {
    setNewProduct(products[index]);
    setEditingIndex(index);
  };

  const handleDelete = async (index, id) => {
    try {
      await axios.delete(`${domain()}?endpoint=products&id=${id}`);
      setProducts(products.filter((_, i) => i !== index));
    } catch (error) {
      console.error('Error deleting product:', error);
    }
  };

  return (
    <div className="p-3 bg-light text-dark rounded" style={{ maxWidth: '800px', margin: '0 auto' }}>
      <h5 className="mb-3 text-center">Products</h5>
      <div className="row">
        <div className="col-md-4 mb-2">
          <label>Product Name</label>
          <input
            type="text"
            className="form-control"
            name="name"
            value={newProduct.name}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-4 mb-2">
          <label>Category</label>
          <select className="form-select" name="category_id" value={newProduct.category_id} onChange={handleChange}>
            <option value="">Select Category</option>
            {categories.map(cat => <option key={cat.id} value={cat.id}>{cat.name}</option>)}
          </select>
        </div>

        <div className="col-md-4 mb-2">
          <label>Subcategory</label>
          <select className="form-select" name="sub_category_id" value={newProduct.sub_category_id} onChange={handleChange}>
            <option value="">Select Subcategory</option>
            {subcategories.map(sub => <option key={sub.id} value={sub.id}>{sub.name}</option>)}
          </select>
        </div>

        <div className="col-md-4 mb-2">
          <label>Counter</label>
          <select className="form-select" name="counter_id" value={newProduct.counter_id} onChange={handleChange}>
            <option value="">Select Counter</option>
            {counters.map(counter => <option key={counter.id} value={counter.id}>{counter.name}</option>)}
          </select>
        </div>

        <div className="col-md-4 mb-2">
          <label>Salesperson</label>
          <select className="form-select" name="salesperson_id" value={newProduct.salesperson_id} onChange={handleChange}>
            <option value="">Select Salesperson</option>
            {salespersons.map(sp => <option key={sp.id} value={sp.id}>{sp.name}</option>)}
          </select>
        </div>

        <div className="col-md-4 mb-2">
          <label>Purity</label>
          <select className="form-select" name="purity_id" value={newProduct.purity_id} onChange={handleChange}>
            <option value="">Select Purity</option>
            {purityLevels.map(purity => <option key={purity.id} value={purity.id}>{purity.name}</option>)}
          </select>
        </div>

        <div className="col-md-4 mb-2">
          <label>Weight</label>
          <input
            type="number"
            className="form-control"
            name="weight"
            value={newProduct.weight}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-4 mb-2">
          <label>Quantity</label>
          <input
            type="number"
            className="form-control"
            name="quantity"
            value={newProduct.quantity}
            onChange={handleChange}
          />
        </div>
        <div className="col-md-4 mb-2">
          <label>Orginal Price</label>
          <input
            type="number"
            className="form-control"
            name="orginal_price"
            value={newProduct.orginal_price}
            onChange={handleChange}
          />
        </div>

        <div className="col-md-12 mb-2 d-flex align-items-end ">
          <button className="btn btn-primary w-100" onClick={handleAddOrUpdateProduct}>
            {editingIndex === -1 ? 'Add Product' : 'Update Product'}
          </button>
        </div>
      </div>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Name</th>
            <th>Category</th>
            <th>Subcategory</th>
            <th>Weight</th>
            <th>Purity</th>
            <th>Quantity</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {products.map((product, index) => (
            <tr key={product.id}>
              <td>{product.name}</td>
              <td>{categories.find(cat => cat.id === product.category_id)?.name || ''}</td>
              <td>{subcategories.find(sub => sub.id === product.sub_category_id)?.name || ''}</td>
              <td>{product.weight}</td>
              <td>{purityLevels.find(purity => purity.id === product.purity_id)?.name || ''}</td>
              <td>{product.quantity}</td>
              <td>
                <button className="btn btn-warning btn-sm me-2" onClick={() => handleEdit(index)}>Edit</button>
                <button className="btn btn-danger btn-sm" onClick={() => handleDelete(index, product.id)}>Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default Products;
